export enum Pronouns {
    Objective = "Objective",
    Subjective = "Subjective",
    Possessive = "Possessive"
}
